import {JSEncrypt} from "jsencrypt";
import sha1 from 'crypto-js/sha1';

function sign(msg, pryKey) {
    var sign = new JSEncrypt();
    sign.setPrivateKey(pryKey);
    return sign.sign(expand(msg), sha1, "sha1");
}

// expand json for sign
function expand(source) {
  if (source instanceof Array) {
    return (
      "[" +
      source
        .map(function (value) {
          return expand(value);
        })
        .join("|") +
      "]"
    );
  }

  if (source instanceof Object) {
    return (
      "(" +
      Object.keys(source)
        .map(function (key) {
          return [key, expand(source[key])];
        })
        .filter(function (kv) {
          return !!kv[1];
        })
        .sort(function (kv1, kv2) {
          return kv1[0].localeCompare(kv2[0]);
        })
        .map(function (kv) {
          return kv[0] + "=" + kv[1];
        })
        .join("&") +
      ")"
    );
  }

  if (source === undefined || source === null) {
    return "";
  }

  return source;
}

export { sign };
